
import { AnnotationPinController } from './annotation-pin.controller'

function annotationPin () {
  return {
    restrict: 'E',
    scope: {
      authorId: '<',
      isHover: '<'
    },
    templateUrl: '/core/directives/annotation-pin/annotation-pin.html?$$REVISION$$',

    controller: AnnotationPinController
  }
}
export { annotationPin }
